import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
import { computed, getCurrentInstance, ref, reactive } from "vue";
import { useStore } from "vuex";
import { ElNotification } from 'element-plus';
import { useRouter } from "vue-router/dist/vue-router";
const __default__ = {
  name: "PersonalInformation"
};
export default /*@__PURE__*/Object.assign(__default__, {
  props: {
    modelValue: {
      type: Boolean,
      default: () => {
        return false;
      }
    }
  },
  emits: ["update:modelValue"],
  setup(__props, {
    emit: __emit
  }) {
    const {
        proxy: this_
      } = getCurrentInstance(),
      store = useStore(),
      router = useRouter();
    const props = __props;
    const emit = __emit;
    const modelValue = computed({
      get: () => props.modelValue,
      set: value => emit("update:modelValue", value)
    });
    const form = reactive({
      nickName: '',
      userName: ''
    });
    const checkAccount = (rule, value, callback) => {
      console.log(rule, value);
      let regex = /^[a-zA-Z0-9]+$/;
      if (!regex.test(value)) {
        callback(new Error('账号必须是字母或数字'));
      } else {
        callback();
      }
    };
    const rules = reactive({
      nickName: [{
        required: true,
        message: '请输入用户名称',
        trigger: 'blur'
      }],
      userName: [{
        required: true,
        message: '请输入用户账号',
        trigger: 'blur'
      }, {
        min: 0,
        max: 16,
        message: '账号长度不超过16个字节',
        trigger: 'blur'
      }, {
        validator: checkAccount,
        trigger: 'blur'
      }]
    });
    const formRef = ref();
    const confirmFn = () => {
      formRef.value.validate(valid => {
        if (valid) {
          this_.$post('system/user/update', {
            nickName: form.nickName,
            userName: form.userName,
            userId: store.getters.userId
          }).then(res => {
            ElNotification.success({
              title: "修改成功",
              customClass: "ApiMessage"
            });
            store.dispatch('getUserInfo');
          }).finally(() => {
            modelValue.value = false;
          });
        }
      });
    };
    const cancel = () => {
      modelValue.value = false;
    };
    const close = () => {
      formRef.value.resetFields();
    };
    const open = () => {
      form.nickName = store.getters.nickName;
      form.userName = store.getters.userName;
      // console.log(store.getters.userName);
      // console.log(store.getters.nickName);
      console.log(store.getters.roleId);
      // console.log(store.getters.userId);
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "个人信息",
        modelValue: modelValue.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => modelValue.value = $event),
        width: "30%",
        "append-to-body": "",
        draggable: "",
        class: "common-dialog-class",
        "close-on-click-modal": false,
        onOpen: open,
        onClose: close
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form,
          ref_key: "formRef",
          ref: formRef,
          rules: rules
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "用户名称",
            prop: "nickName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.nickName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.nickName = $event),
              placeholder: "请输入用户名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "用户账号",
            prop: "userName",
            class: "el-form-item-end"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.userName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.userName = $event),
              placeholder: "请输入用户账号"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: cancel
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          class: "confirm-button-class",
          onClick: confirmFn
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode(" 确认 ")])),
          _: 1
        })])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});